// Import model
import { SectionCondition } from '../models/SectionCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { SectionIndexedFields } from '../models/SectionIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { SectionIndexedFieldsSerializer } from './SectionIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for SectionCondition - handles JSON serialization and deserialization with type validation
 */
export class SectionConditionSerializer {
  /**
   * Deserializes a JSON string into a SectionCondition instance
   */
  static deserialize(json: string): SectionCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a SectionCondition instance
   */
  static fromObject(obj: any): SectionCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to SectionCondition');
    }


    const instance: SectionCondition = {
      fieldName: obj['fieldName'] as SectionIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of SectionCondition instances
   */
  static deserializeArray(json: string): SectionCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a SectionCondition instance to a JSON string
   */
  static serialize(instance: SectionCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a SectionCondition instance to a plain object
   */
  static toObject(instance: SectionCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of SectionCondition instances to a JSON string
   */
  static serializeArray(instances: SectionCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
